import Layout from '@/layout';

const investmentsRoutes = {
  path: '/investments',
  component: Layout,
  redirect: '/investments/list',
  name: 'Investments',
  alwaysShow: true,
  meta: {
    title: 'Inwestycje',
    icon: 'el-icon-office-building',
    permissions: ['view menu administrator'],
  },
  children: [
    {
      path: 'list',
      component: () => import('@/views/investments/List'),
      name: 'InvestmentList',
      meta: { title: 'Lista inwestycji', noCache: true, icon: 'user', permissions: ['manage offer'] },
    },
  ],
};

export default investmentsRoutes;
